<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs>
        <!-- 暗送配置 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.bcc1") }}</span>
          <div class="main ">
            <p>
              <el-button @click="tan()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.bcc2") }}</el-button>
              <el-alert
                :title="this.show_hint"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList"
                v-loading="loading"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="50"
                >
                </el-table-column>
                <el-table-column prop="BCC_ADDRESS" :label="$t('logs.bcc3')">
                </el-table-column>
                <el-table-column prop="BCC_TYPE" :label="$t('logs.bcc4')">
                </el-table-column>
                <el-table-column prop="BCC_TO" :label="$t('logs.bcc5')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('logs.audit6')">
                  <template scope="scope">
                    <!-- 删除 -->
                    <el-button
                    :disabled="$root.jurisdiction.only_query==0"
                      @click="del_bcc(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >{{ $t("table1.delete") }}</el-button
                    >
                    <!-- 编辑 -->
                    <el-button
                    :disabled="$root.jurisdiction.only_query==0"
                      @click="edit_bcc(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_relay_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_relay_domain"><span class="span_pad"></span> {{$t('logs.bcc2')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.bcc3") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="bcc_address" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.bcc5") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="bcc_to" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.bcc4") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="bcc_type" placeholder="请选择">
                      <el-option
                        v-for="item in bcc_type_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_bcc()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
            <div class="pop-up" v-show="tanchu_edit" v-drag="{ handle: '.pop_up_text_relay_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_relay_domain_edit"><span class="span_pad"></span> {{$t('logs.bcc2_edit')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.bcc3") }}:
                  </div>
                  <div class="block block1">
                    <span style="text-align:left;color:#0e2c5e">{{
                      this.bcc_address
                    }}</span>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.bcc5") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="bcc_to" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.bcc4") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="bcc_type" placeholder="请选择">
                      <el-option
                        v-for="item in bcc_type_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="edit_save_bcc()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="edit_tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_edit"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
      tanchu_edit: false,
      bcc_type: 2,
      bcc_type_arr: [],
      bcc_to: "",
      bcc_address: "",
      textarea: "",
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",

      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      options: [
        {
          value: "选项1",
          label: "不使用TLS",
        },
        {
          value: "选项2",
          label: "增加信头标记",
        },
        {
          value: "选项3",
          label: "强制TLS",
        },
      ],
      checked: "",
      fileList: [],
      radio: [],
      show_hint: "",
      loading:false
    };
  },
  mounted() {
    this.getFileList1();
  },
  methods: {
    edit_bcc(index, row) {
      console.log(index, row);
      this.bcc_address = row.BCC_ADDRESS;
      this.bcc_to = row.BCC_TO;
      this.bcc_type = row.BCC_TYPE;
      this.tanchu_edit = true;
    },

    del_bcc(index, row) {
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          // console.log(sid);
          let str = this.$qs.stringify({
            __mode: "del_bcc",
            sid: sid,

            id: row.ID,
          });
          this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
            // console.log(res)
            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.getFileList1();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    edit_save_bcc() {
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_bcc",
        sid: sid,
        // byad: this.byad == true ? 1 : 0,

        bcc_address: this.bcc_address,
        bcc_type: this.bcc_type,

        bcc_to: this.bcc_to,
        newadd: 0,
      });
      this.$axios
        .post(
          "/api/adm/cgi/aspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
this.$close_hint_test();this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu_edit = false;
            this.loading = false;
            this.getFileList1();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    save_bcc() {
  this.$save_hint_test();
  this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_bcc",
        sid: sid,
        // byad: this.byad == true ? 1 : 0,

        bcc_address: this.bcc_address,
        bcc_type: this.bcc_type,

        bcc_to: this.bcc_to,
        newadd: 1,
      });
      this.$axios
        .post(
          "/api/adm/cgi/aspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.tanchu = false;
            this.getFileList1();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    // 过滤单元加载
    getFileList1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "load_bcc",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList = res.data.ret.datalist;
            this.show_hint = res.data.ret.LOAD_HINT;
            this.bcc_type_arr = res.data.ret.q_type;
          }
        });
    },
    edit_tanSend() {
      this.tanchu_edit = false;
    },
    // 显示
    tan: function() {
      this.tanchu = true;
      this.bcc_address = "";
      this.bcc_to = "";
    },
    // 打开关闭
    tanSend: function() {
      this.tanchu = false;
    },

    tanOff: function() {
      this.tanchu = false;
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

/deep/ .el-tabs__nav {
  padding-left: 14px;
}

.main {
  display: flex;
  align-items: center;
  // border: 1px solid #dcdfe6;

  border: 2px solid #d2d7e6;
  // background: #f1f1f1;
  // margin: 10px 0px;

  text-align: left;
  // margin-top: 10px;
}

.main p {
  height: 44px;
  width: 100%;
  display: flex;
  padding-left: 10px;
  font-size: 12px;

  align-items: center;
}
</style>
